import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getContentManagementDataById } from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
  CONTENT_MANAGEMENT_ID,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/aConsoleData";
const aConsoleDataSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {
    renewAcCache: (state, action) => {
      state.data = [...action.payload];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(aConsoleDataThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(aConsoleDataThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(aConsoleDataThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const aConsoleDataThunk = createAsyncThunk(
  `${sliceName}/aConsoleDataThunk`,
  async () => {
    const response = await getContentManagementDataById(CONTENT_MANAGEMENT_ID.ADMIN_CONSOLE)();
    return { data: response };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.aConsoleData);
    },
  },
);

export const { renewAcCache } = aConsoleDataSlice.actions;
export default aConsoleDataSlice.reducer;
